/**
 * @fileoverview InsightBox brand mark for the Sales module's header.
 * @description The InsightBox "IB" mark (the same `favicon.svg` the browser tab uses) shown next
 * to "InsightBox Sales" in the header, replacing the earlier text-monogram badge — mirrors
 * `BankBadge`'s role in the Banking module's own header. The mark is served straight from
 * `public/` so the tab icon and the header icon always come from one single file.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Rahul Chawda
 */

/** Public URL of the InsightBox mark — the one file also used as the browser tab icon. */
const BRAND_MARK_URL = '/favicon.svg'

interface SalesBadgeProps {
  size?: number
}

/**
 * @component
 * @param {SalesBadgeProps} props - The badge's size.
 * @param {number} [props.size] - Width and height in pixels. Defaults to 32.
 */
function SalesBadge({ size = 32 }: SalesBadgeProps) {
  return (
    <img src={BRAND_MARK_URL} alt="" className="shrink-0" style={{ width: size, height: size }} />
  )
}

export default SalesBadge
